module.exports = __webpack_public_path__ + "static/media/pinpoint2.5068fd47.jpg";